export class CustomContextPadProvider {
    // @ts-expect-error
    constructor(contextPad) {
        contextPad.registerProvider(this);
    }

    /**
     * @param {any} element
     */
    getContextPadEntries(element) {
        return function (/** @type {{ [x: string]: any; }} */ entries) {
            if (process.env.REACT_APP_NON_FILTERED_BPMN_ELEMENTS === 'false') {
                delete entries['replace'];
            }
            return entries;
        };
    }
}

CustomContextPadProvider.$inject = ['contextPad'];
